import React, { memo } from "react";
import { Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import RequiredTitle from "./RequiredTitle";

const PhoneInputField = ({ input, control, error, defaultValue }) => {
  const { name, type, label, validation, alignment = {}, defaultValues = defaultValue, ...rest } = input;
  const { sm = 12, md = 12, lg = 12} = alignment;

  return (
    <div
      key={name}
      className={`form-group mb-3 col-sm-${sm} col-md-${md} col-lg-${lg}`}
    >
      <RequiredTitle
        label={label}
        validation={validation}
      />
      <Controller
        name={name}
        control={control}
        rules={validation}
        defaultValue={defaultValues}
        render={({ field }) => (
          <>
            <PhoneInput
              {...field}
              country={"in"}
              inputStyle={{
                width: "100%",
                height: "3.5rem",
              }}
            />
            {error && <div className="invalid-feedback">{error}</div>}
          </>
        )}
      />
    </div>
  );
};

export default memo(PhoneInputField);
